import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../../../interfaces/IReduxState";

export const BookletRequestDecisionSlice = createSlice({
  name: "BookletRequestDecisionSlice",
  initialState: {} as IReduxState<any>,
  reducers: {
    bookletRequestDecision: (state, _: PayloadAction<any>) => {
      state.isLoading = true;
    },
    successBookletRequestDecision: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureBookletRequestDecision: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearBookletRequestDecision: (state) => {
      state.data = {};
    },
  },
});

export const {
  bookletRequestDecision,
  failureBookletRequestDecision,
  successBookletRequestDecision,
  clearBookletRequestDecision,
} = BookletRequestDecisionSlice.actions;

export default BookletRequestDecisionSlice.reducer;
